<template>

    <div class="package-discount-container" v-wechat-title="'mysread'">

        <vue-element-loading :active="isRequest" :is-full-screen="true" spinner="bar-fade-scale" color="#FF6700" />

        <!--頂部欄-->
        <div class="top-nav-container">
            <span>打折專區</span>
            <span @click="backClick" style="position: absolute;left: 10px">返回</span>
        </div>

        <div style="margin-top: 70px">
            <div v-for="discountBook in discountList" style="display: flex;flex-direction: column;margin-top: 10px">
                <div class="book-container">
                    <img :src="discountBook.books[0].pic1">
                    <ul>
                        <li>
                            <span style="font-weight:bold;color: black">{{discountBook.books[0].title}}</span>
                        </li>
                        <li>
                            <span>{{discountBook.books[0].author}}</span>
                        </li>
                        <li>
                            <span class="book-dis">{{discountBook.books[0].content}}</span>
                        </li>
                    </ul>

                    <a @click="buyDiscountBook(discountBook)" class="buy">點擊購買</a>

                </div>
                <div style="display: flex;flex-direction: row;margin-top: 10px">
                    <div class="book-container">
                        <img :src="discountBook.books[1].pic1" style="width: 40%;max-height: 80%">
                        <ul>
                            <li>
                                <span style="font-size: 12px;color: black;font-weight: bold">{{discountBook.books[1].title}}</span>
                            </li>
                            <li>
                                <span style="font-size: 12px">{{discountBook.books[1].author}}</span>
                            </li>
                            <li>
                                <span class="book-dis" style="font-size: 10px">{{discountBook.books[1].content}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="book-container">
                        <img :src="discountBook.books[2].pic1" style="width: 40%;max-height: 80%">
                        <ul>
                            <li>
                                <span style="font-size: 12px;color: black;font-weight: bold">{{discountBook.books[2].title}}</span>
                            </li>
                            <li>
                                <span style="font-size: 12px">{{discountBook.books[2].author}}</span>
                            </li>
                            <li>
                                <span class="book-dis" style="font-size: 10px">{{discountBook.books[2].content}}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div style="width: 100%;height: 1px;background-color: lightgray"></div>

            </div>

            <div class="dialog" v-show="showBuyView">
                <div class="border">
                    <h4>購買文包</h4>
                    <p>(已購買章節不重復進行計算)</p>
                    <p>原價：{{price1}}異幣</p>
                    <p>折扣價：{{price2}}異幣</p>
                    <div style="width: 100%;height: 1px;background-color: lightgray"></div>
                    <div>
                        <a @click="cancel">取消</a>
                        <a @click="confirm">確定</a>
                    </div>
                </div>
            </div>

        </div>

    </div>

</template>

<script>
import axios from "axios";

export default {
    name: "packageDiscountVue",
    data() {
        return {
            userId: "",
            discountList: [],
            isRequest: false,
            showBuyView: false,
            discountBookId: "",
            price1: "",
            price2: "",
        };
    },
    methods: {
        //返回
        backClick: function () {
            this.$router.go(-1);
        },

        //獲取打折書籍
        getDiscountBooks: function () {
            this.isRequest = true;
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "getChosenDiscountList");
            params.append("type", "2");
            this.$http.post(axios.baseURL, params).then((res) => {
                this.isRequest = false;
                alert(res.data.msg);
                if (res.data.status) {
                    this.discountList = res.data.data;
                }
            });
        },

        //購買
        buyDiscountBook: function (book) {
            this.discountBookId = book.groupId;
            this.price1 = book.originalPrice;
            this.price2 = book.price;
            this.showBuyView = true;
        },

        //取消
        cancel: function () {
            this.showBuyView = false;
        },

        //確定
        confirm: function () {
            if (this.userId !== null && this.userId !== "null") {
                this.isRequest = true;
                const params = new URLSearchParams();
                params.append("language", "zh-Hant");
                params.append("dev", "h5");
                params.append("uuid", "123456");
                params.append("ver", "1.0");
                params.append("ac", "buyDiscount6");
                params.append("groupId", this.discountBookId);
                params.append("uid", this.userId);
                this.$http.post(axios.baseURL, params).then((res) => {
                    this.isRequest = false;
                    this.showBuyView = false;
                    if (res.data.status) {
                        this.getDiscountBooks();
                    } else {
                        alert(res.data.msg);
                    }
                });
            } else {
                this.$router.push({
                    path: "LoginVue",
                });
            }
        },
    },
    created() {
        this.userId = localStorage.getItem("userId");
        this.getDiscountBooks();
    },
};
</script>

<style scoped>
.package-discount-container {
    max-width: 480px;
    min-height: 100vh;
    margin: 0 auto;
    border: 1px solid lightgoldenrodyellow;
}

.book-container {
    width: 100%;
    text-align: left;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    flex-direction: row;
}

.book-container img {
    width: 25%;
    height: 100px;
    min-height: 100px;
    max-height: 100px;
}

.book-container ul {
    padding-inline-start: 10px;
}

.book-container ul li {
    list-style: none;
    line-height: 20px;
}

.book-container ul li span {
    color: #999999;
    font-size: 14px;
}

.buy {
    position: absolute;
    right: 10px;
    cursor: pointer;
    border: 1px solid gray;
    border-radius: 3px;
    padding: 3px 10px;
    background-color: white;
    color: deepskyblue;
}

.book-dis {
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    line-height: 20px;
    height: 60px;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    text-decoration: none;
}

.dialog {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
}

.border {
    text-align: center;
    background-color: white;
    border-radius: 10px;
    width: 70%;
    height: 30%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.border h4 {
    margin-top: 20px;
}

.border p {
    font-size: 16px;
}

.border div {
    height: 60px;
    display: flex;
    flex-direction: row;
}

.border div a {
    line-height: 60px;
    width: 50%;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/PackageDiscountVue.vue